import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { AddCompanyPoRequest } from '../models/request/companyPo/AddCompanyPoRequest';
import { GetCompanyPoListPagingAndFilterRequest } from '../models/request/companyPo/GetCompanyPoListPagingAndFilterRequest';
import { CustomSingleSelectModel } from '../components/CustomSingleSelect';

export class CompanyPoService {
    static async getCompanyPoList(_date: string | undefined, _selectedCustomer: CustomSingleSelectModel | undefined, _selectedDivision: CustomSingleSelectModel | undefined, _projectKey?: string, _onlyCustomActive?: boolean) {
        try {
            var inputObj = {
                date: _date,
                selectedCustomer: _selectedCustomer,
                selectedDivision: _selectedDivision,
                projectKey: _projectKey,
                onlyCustomActive: _onlyCustomActive
            };

            console.log('SERVICE CALL - getCompanyPoList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/CompanyPo/getCompanyPoList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportCompanyPoList(inputObj: GetCompanyPoListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportCompanyPoList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/CompanyPo/exportCompanyPoList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getCompanyPoListPagingAndFilter(inputObj: GetCompanyPoListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetCompanyPoListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/CompanyPo/GetCompanyPoListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async addCompanyPo(inputObj: AddCompanyPoRequest) {
        try {
            console.log('SERVICE CALL - AddCompanyPo', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/CompanyPo/AddCompanyPo', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteCompanyPo(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteCompanyPo', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/CompanyPo/deleteCompanyPo', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getCompanyPoById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getCompanyPoById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/CompanyPo/getCompanyPoById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}